const documentName = (document) => {
  let documentParts = document.split('/')
  return documentParts[documentParts.length - 1]
}

export default documentName
